import { Base } from '@studiometa/js-toolkit';

/**
* AddToCartSticky component
*/
export default class AddToCartSticky extends Base {
    isSticky = false;

    /**
    * Component Configuration
    */
    static config = {
        name: 'AddToCartSticky',
    };

    mounted() {

      const mainWrapper = document.querySelector('.product-info__block-item[data-block-type="variant-picker"]');
      const stickyWrapper = document.querySelector('.product-sticky-bar__info');

      const mainInputs = (() => {
        const inputs = mainWrapper.querySelectorAll('input[value]');
        const map = new Map();
        inputs.forEach(input => {
          const value = input.value?.trim();
          if (value) {
            map.set(value, input);
          }
        });
        return map;
      })();

      this.syncVariantInputsByValue(mainWrapper, stickyWrapper);
      this.connectListboxToMainInputs(stickyWrapper, mainInputs);
      this.clickStickyAddToCartButton();
    }

    /**
     *
     * Sync Variant inputs by Value between ProductInfo and StickyBar
     * @param {*} mainWrapper
     * @param {*} stickyWrapper
     * @returns
     */
    syncVariantInputsByValue(mainWrapper, stickyWrapper) {
      if (!mainWrapper || !stickyWrapper) return;

      const getInputsMap = (wrapper) => {
        const inputs = wrapper.querySelectorAll('[value]');
        const map = new Map();
        inputs.forEach(input => {
          map.set(input.value, input);
        });
        return map;
      };

      const mainInputs = getInputsMap(mainWrapper);
      const stickyInputs = getInputsMap(stickyWrapper);

      mainInputs.forEach((mainInput, value) => {
        const stickyInput = stickyInputs.get(value);
        if (stickyInput) {
          mainInput.addEventListener('click', () => {

            // Fake Click on sticky input
            if (!stickyInput.checked) stickyInput.click();

            // Price update
            this.updateStickyPrice();

            // Update swatch
            this.replaceSwatch(stickyInput, stickyWrapper);

          });
        }
      });

      stickyInputs.forEach((stickyInput, value) => {
        const mainInput = mainInputs.get(value);
        if (mainInput) {
          stickyInput.addEventListener('click', () => {
            if (!mainInput.checked) mainInput.click();
          });
        }
      });
    }

    connectListboxToMainInputs(stickyWrapper, mainInputs) {
      if (!stickyWrapper || !mainInputs) return;

      const listboxButtons = stickyWrapper.querySelectorAll('x-listbox button[role="option"][value]');

      listboxButtons.forEach(button => {
        const value = button.value?.trim();
        if (!value) return;

        button.addEventListener('click', () => {
          const matchingMainInput = mainInputs.get(value);
          if (matchingMainInput && !matchingMainInput.checked) {
            matchingMainInput.click();
            this.replaceSwatch(button);
          }
        });
      });
    }

    /**
     * Replace the swatch in the fake select
     * @param {*} source - Element containing the source swatch (button or stickyInput)
     * @param {*} stickyWrapper - Optional wrapper element for sticky version
     */
    replaceSwatch(source, stickyWrapper = null) {
      let swatch;
      let fieldset;

      if (stickyWrapper) {
        // Handle sticky input case
        if (!source) return;
        swatch = source.nextElementSibling;
        if (!swatch?.classList.contains('color-swatch')) return;
        fieldset = stickyWrapper.querySelector('fieldset[name="Couleur"]');
        if (!fieldset) return;
      } else {
        // Handle button case
        swatch = source.querySelector('.color-swatch');
        if (!swatch) return;
        fieldset = swatch.closest('fieldset');
      }

      const fakeSelect = fieldset.querySelector('button.select');
      const existingSwatch = fakeSelect.querySelector('.color-swatch');
      existingSwatch.parentNode.insertBefore(swatch.cloneNode(true), existingSwatch);
      existingSwatch.remove();
    }

    /**
     * Click on the sticky add to cart button and fake click on the main add to cart button
     */
    clickStickyAddToCartButton() {
      const StickyAddToCartButton = this.$el.querySelector('.product-sticky-bar__add-to-cart');
      const addToCartButton = document.querySelector('.product-info form buy-buttons button[type="submit"]');
      StickyAddToCartButton.addEventListener('click', () => {
        addToCartButton.click();
      });
    }

    /**
     * Update the sticky add to cart button on form variant change
     */
    updateStickyPrice() {
      const form = document.querySelector('.product-info .product-info__block-item[data-block-type="buy-buttons"] form.shopify-product-form');
      const variantIdInput = form.querySelector('input[name="id"]');

      if (!variantIdInput) return;

      variantIdInput.addEventListener('change', () => {
        const variantId = variantIdInput.value; // 🔁 lire la valeur AU MOMENT DU CHANGEMENT
        if (!variantId) return;

        const variant = window.productVariants.find(v => v.id == variantId);
        if (variant) {

          const stickyButton = this.$el.querySelector('.product-sticky-bar__add-to-cart');
          if (!stickyButton) return;

          const price = variant.price.toString().replace(',00', '');

          if (!variant.available) {
            stickyButton.textContent = "Victime de son succès";
            stickyButton.classList.add('tw-pointer-events-none');
            stickyButton.classList.remove('tw-pointer-events-auto');
          } else {
            stickyButton.textContent = `Ajouter · ${price}€`;
            stickyButton.classList.remove('tw-pointer-events-none');
            stickyButton.classList.add('tw-pointer-events-auto');
          }

        } else {
          console.warn("Variante non trouvée pour l'ID :", variantId);
        }
      });
    }


  }
